import * as moment from 'moment'

import { CredentialSet } from './credential-set'
import { EligibilityRuleSet } from './eligibility-rule-set'
import { EligibilityStatusTag } from './eligibility-status-tag'
import { Membership } from './membership'
import { MembershipDefinition } from './membership-definition'
import { Organization } from './organization'

class CardMembershipDefinition extends MembershipDefinition {
  public organization: Organization
}

export class CardMembership extends Membership {
  public eligibility_rule_set: EligibilityRuleSet
  public membership_affiliation_path: any[]
  public parent_membership_definitions: CardMembershipDefinition[]
  public persona_eligibility: any

  private readonly statusColorMap: object = {
    eligible: 'green',
    ineligible: 'yellow',
    incomplete_complete: 'yellow',
    incomplete: 'yellow',
    expired: 'red',
    canceled: 'red',
    suspended: 'red',
    upcoming: 'primary'
  }

  public get credentialSet(): CredentialSet {
    return this.persona_eligibility.credential_sets.find((cs) => cs.trigger_credential_value === this.id)
  }

  public get hasEligibility(): boolean {
    return this.persona_eligibility.eligibility_credentials.find((cred) => {
      if (cred.credential_type === 'suspension') return cred.eligibility_status === 'suspended'
      return cred.rule_type !== 'membership_definition'
    })
  }

  public tag(timezone: string): EligibilityStatusTag {
    const status = this.credentialSet.eligibility_status.toLowerCase()
    let value = ['eligible', 'upcoming', 'suspended'].includes(status) ? status : 'ineligible'
    const color = this.statusColorMap[value]
    if (value === 'upcoming') value = `starts ${moment.tz(this.effective_at, timezone).format('MMM D, YYYY')}`
    return new EligibilityStatusTag({ value, color })
  }

}
